import React, {FunctionComponent} from "react";
import {Typography} from "@material-ui/core";

type TextProps = {
    value: string;
    size: number;
    color?: string;
    centered?: boolean;
    absolute?: boolean;
    width?: number;
};

const Text: FunctionComponent<TextProps> = ({size, value, color = "#000", centered, width}) => (
    <Typography style={{
        fontSize: size,
        color,
        letterSpacing: 0.25,
        textAlign: centered ? "center" : undefined,
        whiteSpace: "pre-line",
        padding: 0,
        margin: 0,
        width
    }}>{value}</Typography>
);

export default Text;
